import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class ZohoIntegrationServices {
  /**
   * @param orgId
   * @param {*} payload
   * @return
   */
  getZohoConnections = async (orgId) => {
    let url = `${Constants.GET_ZOHO_CONNECTIONS}`;
    if (orgId) url += `?temp_org_id=${orgId}&`;
    const getZohoConnections = await Helpers.get({
      url,
    });
    return getZohoConnections;
  }

  /**
   *
   * @param orgId
   * @return
   */
  connectToZoho = async (orgId) => {
    let url = `${Constants.CONNECT_TO_ZOHO}`;
    if (orgId) url += `?org_id=${orgId}&`;

    const connectToZoho = await Helpers.get({
      url,
    });
    return connectToZoho;
  }

  /**
   *
   * @param {*} payload
   * @returns
   */
  updateZohoConnection = async (payload) => {
    const url = `${Constants.UPDATE_ZOHO_CONNECTION}`;
    const updateZohoConnection = await Helpers.post({
      url,
      data: payload,
    });
    return updateZohoConnection;
  }

  /**
   *
   * @param {*} payload
   * @returns
   */
  syncProduct = async (payload) => {
    const url = `${Constants.SYNC_ZOHO_PRODUCT}`;
    const syncProduct = await Helpers.post({
      url,
      data: payload,
    });
    return syncProduct;
  }

  /**
   *
   * @param {*} payload
   * @returns
   */
  syncVendor = async (payload) => {
    const url = `${Constants.SYNC_ZOHO_VENDOR}`;
    const syncVendor = await Helpers.post({
      url,
      data: payload,
    });
    return syncVendor;
  }

  /**
  *
  * @param {*} payload
  * @returns
  */
  syncGRN = async (payload) => {
    const url = `${Constants.SYNC_ZOHO_GRN}`;
    const syncGRN = await Helpers.post({
      url,
      data: payload,
    });
    return syncGRN;
  }

  /**
  *
  * @param {*} payload
  * @returns
  */
  syncPO = async (payload) => {
    const url = `${Constants.SYNC_ZOHO_PO}`;
    const syncPO = await Helpers.post({
      url,
      data: payload,
    });
    return syncPO;
  }

  /**
  *
  * @param {*} payload
  * @returns
  */
  syncInvoice = async (payload) => {
    const url = `${Constants.SYNC_ZOHO_INVOICE}`;
    const syncInvoice = await Helpers.post({
      url,
      data: payload,
    });
    return syncInvoice;
  }

  /**
  *
  * @param {*} payload
  * @returns
  */
  syncCN = async (payload) => {
    const url = `${Constants.SYNC_ZOHO_CN}`;
    const syncCN = await Helpers.post({
      url,
      data: payload,
    });
    return syncCN;
  }

  /**
   *
   * @param {*} payload
   * @returns
   */
  syncDN = async (payload) => {
    const url = `${Constants.SYNC_ZOHO_DN}`;
    const syncDN = await Helpers.post({
      url,
      data: payload,
    });
    return syncDN;
  }

  /**
   *
   * @param {*} payload
   * @returns
   */
  pullProducts = async (payload) => {
    const url = `${Constants.PULL_ZOHO_PRODUCTS}`;
    const pullProducts = await Helpers.post({
      url,
      data: payload,
    });
    return pullProducts;
  }

  /**
   *
   * @param {*} payload
   * @returns
   */
  pullVendors = async (payload) => {
    const url = `${Constants.PULL_ZOHO_VENDORS}`;
    const pullVendors = await Helpers.post({
      url,
      data: payload,
    });
    return pullVendors;
  }

  /**
   *
   * @param {*} payload
   * @returns
   */
  pullCustomers = async (payload) => {
    const url = `${Constants.PULL_ZOHO_CUSTOMERS}`;
    const pullCustomers = await Helpers.post({
      url,
      data: payload,
    });
    return pullCustomers;
  }

  connectTenantToLocation = async (payload) => {
    const url = `${Constants.CONNECT_TENANT_TO_LOCATION}`;
    const connectTenantToLocationData = await Helpers.post({
      url,
      data: payload,
    });
    return connectTenantToLocationData;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  deleteZohoConnection = async (payload) => {
    const deleteZohoConnection = await Helpers.delete({
      url: Constants.DELETE_ZOHO_CONNECTION,
      data: payload,
    });
    return deleteZohoConnection;
  }

  // auto sync zoho documents
  syncZohoDocument = async (payload) => {
    const url = `${Constants.ZOHO_AUTOMATIC_DOC_SYNC}`;
    const syncZohoDocument = await Helpers.post({
      url,
      data: payload,
    });
    return syncZohoDocument;
  }
}
export default new ZohoIntegrationServices();
